<template>
  <div class="advantage">
    <div class="contents contents-advantage">
        <div class="left">
            <img :src="brandAdvantage.titleImg" />
        </div>
        <div class="right">
            <p class="one-title">{{brandAdvantage.oneTitle}}</p>
            <p class="two-title">{{brandAdvantage.twoTitle}}</p>
            <ul class="advangtage-ul">
                <li class="advangtage-li" v-for="(item,index) in brandAdvantage.list" :key="index">
                    <i class="icon iconfont icon-yuandianzhong"></i><p>{{item}}</p>
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        brandAdvantage: {
            type: Object,
            default: function(){
                return {}
            }
        }
    },
}
</script>

<style scoped>
    .advantage{
        overflow: hidden;
        background: url(/static/brand/aboutusbj.png) no-repeat center top;
    }
    .contents-advantage{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 60px auto;
    }
    .contents-advantage .left{
        width: 520px;
    }
    .contents-advantage .left img{
        width: 100%;
    }
    .contents-advantage .right{
        width: 640px;
    }
    .right .one-title{
        font-weight: 700;
        font-size: 32px;
        line-height: 36px;
        color: #333333;
    }
    .right .two-title{
        position: relative;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 1.5796px;
        color: #666666;
        margin-bottom: 14px;
        margin-top:9px
    }
    .right .two-title::after{
        content: " ";
        position:absolute;
        left:0;
        bottom: -2px;
        width: 35px;
        height: 2px;
        background-color: #FBB113;
    }
    .advangtage-ul .advangtage-li{
        color: #333333;
        letter-spacing: 1.4px;
        font-size: 16px;
        line-height: 27px;
        margin-top: 10px;
        display: flex;
    }
    .advangtage-ul .advangtage-li .icon{
        color: #FBB113;
        font-size: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/brand/BrandAdvantage.vue